import { render, staticRenderFns } from "./ThgBillingListView.vue?vue&type=template&id=5b89b2a6&"
import script from "./ThgBillingListView.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports